<template>
  <div class="gj_right" style="min-height: 0px;">
    <div class="add_con_man">
      <form novalidate class="class_add_con w622 col_2_1" data-vv-scope="form" style="min-height: auto;">
        <table width="100%" border="0" cellspacing="0" cellpadding="0">
          <tbody>
          <tr>
            <td align="right"><b>*</b>姓名：</td>
            <td class="pl_10">
              <input type="text" name="name" class="put_add_text" placeholder="姓名" disabled v-model="form.name">
            </td>
            <td rowspan="4" align="right" style="position: relative; border-bottom: 0; padding-right: 10px;">
              <img v-if="form.photo && form.photo!==''" :src="form.photo"  width="151" height="151"/>
              <div v-else style="width: 151px; height: 151px; border: 1px solid #d6d6d6; text-align: center;">暂无头像</div>
            </td>
          </tr>
          <tr>
            <td width="74" align="right"><b>*</b>身份证：</td>
            <td width="360" class="pl_10">
              <input type="text" name="idCard" class="put_add_text" placeholder="身份证号" disabled v-model="form.idCard">
            </td>
          </tr>
          <tr>
            <td align="right"><b>*</b>手机号：</td>
            <td class="pl_10">
              <input type="text" name="mobile" class="put_add_text" placeholder="手机号" disabled v-model="form.mobile">
            </td>
          </tr>
          <tr>
            <td align="right">性别：</td>
            <td class="pl_10">
              <div style="float: left; padding-left: 24px;">
                <input class="userinfo_radio" disabled type="radio" name="sex" value="0" v-model="form.sex"> 男　
                <input class="userinfo_radio" disabled type="radio" name="sex" value="1" v-model="form.sex"> 女
              </div>
            </td>
          </tr>
          <tr>
            <td align="right">职务：</td>
            <td class="pl_10">
              <div style="float: left; padding-left: 24px;">
                <select name="job" class="all_select" v-model="form.post" disabled>
                  <option value="销售组">销售组</option>
                  <option value="技术组">技术组</option>
                </select>
              </div>
            </td>
          </tr>
          <tr>
            <td align="right">公司：</td>
            <td class="pl_10">
              <input type="text" name="company" class="put_add_text" disabled v-if="form.depList" v-model="form.depList[0].dep.name">
            </td>
          </tr>
          </tbody>
        </table>
      </form>
    </div>
  </div>
</template>

<script>
  import { getCookie, saveCookie, removeCookie } from '@/store/cookies.js'
  import '@/utils/validator.js'
  export default {
    components: {  },
    props: ['params'],
    data () {
      return {
        outputs: {
          isValidate: true
        },
        form: {},
        uploadOSSConf: { showMode: '1', style: 'img_upload4', typeArr: 'image/png,image/jpg,image/jpeg', catalog: 'byl', fileName: '', maxSize: '2000000', STS: null }
      }
    },
    computed: {
      hasCheckBox () {
        if (this.params.inputs.showCheckBox) {
          return this.params.inputs.showCheckBox
        }
        return false
      }
    },
    created () {
    },
    mounted () {
      if (this.params.inputs.data && this.params.inputs.data.length > 0) { // 编辑
        this.form = this.params.inputs.data[0]
        // this.$validator.reset({scope: 'form'})
        this.outputs.data = this.form
        this.outputs.isValidate = true
      } else { // 新增
        this.outputs = {
          data: this.form
        }
      }
    },
    watch: {
      form: {
        handler: function (val, oldVal) {
          this.$validator.validateAll('form').then((result) => {
            this.outputs.isValidate = result
            this.outputs.data = val
          })
        },
        deep: true
      }
    },
    methods: {
    }
  }
</script>

<style scoped>
  .px_add_con table thead tr { background: none; }
  .userinfo_radio { opacity: 1; }
</style>



// WEBPACK FOOTER //
// src/components/byl/InfoBox/noEdit.vue